import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useToast } from "../../../Services/ToastContext";
import {
  GeneralResponse,
  IuserDetails,
} from "../../../interface/GeneralResponse";
import Api from "../../generalApi/Api";
import { Methods } from "../../../Constants/ApiConstants";
import { EndPoints } from "../../../Constants/endpoints";
import { nextStep } from "../../../redux/reducers/registrationSlice";

export interface VerifyCodeRegisterRequest {
  Id: number;
  VerificationCode: string;
}

const useVerifyCodeRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const mutation = useMutation({
    mutationFn: async (
      data: VerifyCodeRegisterRequest,
    ): Promise<GeneralResponse<IuserDetails>> => {
      const response = await Api<
        VerifyCodeRegisterRequest,
        GeneralResponse<IuserDetails>
      >({
        method: Methods.POST,
        endpoint: EndPoints.VerifyNumber,
        body: data,
      });

      if (!response.Status) {
        throw new Error(response.ErrorMessage || "Invalid Verification Code");
      }

      return response;
    },
    onSuccess: () => {
      dispatch(nextStep());
      navigate("/Password-register");
    },
    onError: (error: any) => {
      showToast(error.message || "An error occurred", "error");
    },
  });

  return mutation;
};

export default useVerifyCodeRegister;
